module.exports = __webpack_public_path__ + "img/arrow-turn-down.9ce2a440.svg";